<template>
  <div :key="commonStore.resetKey" class="left-nav-layout">
    <header>
      <LeftNavHeader />
    </header>
    <aside>
      <CategorySidebar />
    </aside>
    <main><slot /></main>
  </div>
</template>

<script lang="ts" setup>
  import CategorySidebar from '@/components/CategorySidebar.vue';
  import LeftNavHeader from '@/components/LeftNavHeader.vue';
  import { useCommonStore } from '@/stores/common';
  import { useConfigStore } from '@/stores/config';
  import { onBeforeMount } from 'vue';
  import { useRouter } from 'vue-router';

  const router = useRouter();
  const commonStore = useCommonStore();
  const configStore = useConfigStore();

  onBeforeMount(async () => {
    // 필수값 체크
    if (!configStore.config.StoreID || !configStore.config.SubStoreCode) {
      router.replace('/login');
      return;
    }
  });
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .left-nav-layout {
    display: grid;
    grid-template-rows: vars.$left-nav-header-height 1fr;
    grid-template-columns: vars.$left-nav-width 1fr;
    height: 100vh;
    background-color: var(--main-bg);

    header {
      grid-column: 1 / 3;
    }

    main {
      background-color: var(--main-bg);
    }
  }
</style>
